import React, { FC, useState } from 'react';
import {
  PermissionGroup,
  PoliciesPermissionSetItems as Permission,
} from 'common/constants/permissions';
import { IEmployeeRole } from 'common/interfaces/employee';
import { ISecurityPolicyDto } from 'common/interfaces/permissions';
import { getArray } from 'common/utils/typeUtils';
import { getPermissionsFilteredArray } from 'modules/permissions/utils/permission';
import { CollapsedComponent } from 'modules/permissions/components/index';

interface IViewRoleModalContent {
  role: IEmployeeRole;
}

const ViewRoleModalContent: FC<IViewRoleModalContent> = ({ role }) => {
  const [hideUnchecked, setHideUnchecked] = useState(true);
  const securityPolicyDtoList = getArray<ISecurityPolicyDto>(role.securityPolicyDtoSet);
  const permissionSet: Permission[] = [];
  const permissionGroups: PermissionGroup[] = [];

  for (const securityPolicy of securityPolicyDtoList) {
    permissionSet.push(...securityPolicy.permissionSet);
    permissionGroups.push(securityPolicy.permissionGroup);
  }

  const permissionsArray = getPermissionsFilteredArray(role.level, hideUnchecked, permissionGroups);

  return (
    <CollapsedComponent
      permissions={permissionsArray}
      permissionSet={permissionSet}
      onHideUnchecked={setHideUnchecked}
      hideUnchecked={hideUnchecked}
    />
  );
};

export default ViewRoleModalContent;
